import React from 'react';
import { useParams } from 'react-router';
import css from './index.module.css';
import ExcelButtonNew from '../../../../components/common/table/excel-button/excel-button-new';
import { useService } from '../../../../services/services';
import Animal from '../../../../interfaces/animal';


export default function AnimalExportButton({
  animals
}: {
  animals: Animal[]
}) {
  const { farmId } = useParams<{ farmId: string }>();
  const { animalService } = useService();

  const onClick = () => {
    return animalService
      .exportXls(farmId, {
        animal_id: animals.map(animal => animal.animal_id),
        all_animals: true,
      })
      .subscribe();
  };

  return (
    <div className={css['excel-export']}>
      <ExcelButtonNew
        onClick={onClick}
      />
    </div>
  );
}
